<template>
    <div>
        <b-modal
            id="modify-liveness-detection-popup"
            :title="titlePopup"
            ref="modal"
            size="sm"
            hide-footer
            modal-class="hide-footer"
            no-close-on-backdrop
            :hide-header-close="loading"
            no-close-on-esc
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="liveness-detection-matched-1"
                            :label="popupLabel"
                            :label-for="popupLabel"
                        >
                            <b-form-input
                                id="liveness-detection-matched-input"
                                v-model="formData.threshold"
                                v-validate="{
                                    required: true,
                                    regex: /^([0-9]*)$/,
                                    min: 1,
                                    max: 3,

                                    max_value: 100,
                                    min_value: 1,
                                }"
                                type="text"
                                :placeholder="popupPlaceholder"
                                name="threshold"
                                :class="{
                                    'is-invalid': errors.has('threshold'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Update"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup']),

        titlePopup() {
            return 'Modify ' + (this.selectedItem ? this.formData.type : '')
        }, // End of titlePopup() method
        popupLabel() {
            return (
                (this.selectedItem ? this.formData.type : '') +
                ' Matched Threshold'
            )
        }, // End of popupLabel() method
        popupPlaceholder() {
            return 'Enter ' + (this.selectedItem ? this.formData.type : '')
        }, // End of popupPlaceholder() method

        // buttonLabel() {
        //     return this.selectedItem ? 'Update' : 'Create'
        // },
    }, // End of Component > methods
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, value)
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                threshold: '',
                type: '',
            }
        }, // End of initializeFormData() method

        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method

        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    await this.$store.dispatch('onSubmit', this.formData)
                } catch (error) {
                    // console.log(error, 'There is an error on submit')
                }
            }
        }, // End of onSubmit() method
    }, // End of Component > watch
}
</script>
